import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionWeightLogCreatePayload,
	IActionWeightLogCreatePayloadDone,
	IActionWeightLogCreatePayloadError,
} from './types';

export const weightLogCreate = actionCreatorAsync<
	IActionWeightLogCreatePayload,
	IActionWeightLogCreatePayloadDone,
	IActionWeightLogCreatePayloadError
>(
	'weightLogCreate',
	async (params) => {
		const { weightLog } = params;
		const { data } = await Api.weightLog.create({
			body: weightLog,
		});

		return data;
	},
);
